// ======================================================================
// File Name       : initialImage
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/initialImage';
import { INITIAL_IMAGE, ITEM_IMAGE_TYPE, TITLE_OBJ, TITLE_OBJ_STR } from '../constants/InitialImageConstants';

const initialState = {
  initialData: {
    imageFileSelectType: INITIAL_IMAGE.IMAGE_SYSTEMS,
    imageType: null,
    imageFileUpload: null,
    thumbnailUrl: '',
  },
  initialImageList: [],
  initialImageObject: null,
};

function addNameAndTitle(obj, index) {
  switch (index) {
    case 0:
      obj.name = TITLE_OBJ.COURSE;
      obj.titleName = TITLE_OBJ_STR.COURSE;
      break;
    case 1:
      obj.name = TITLE_OBJ.BOX;
      obj.titleName = TITLE_OBJ_STR.BOX;
      break;
    case 2:
      obj.name = TITLE_OBJ.DRILL;
      obj.titleName = TITLE_OBJ_STR.DRILL;
      break;
    case 3:
      obj.name = TITLE_OBJ.TEST;
      obj.titleName = TITLE_OBJ_STR.TEST;
      break;
    case 4:
      obj.name = TITLE_OBJ.REPORT;
      obj.titleName = TITLE_OBJ_STR.REPORT;
      break;
    case 6:
      obj.name = TITLE_OBJ.LINK;
      obj.titleName = TITLE_OBJ_STR.LINK;
      break;
    default:
      break;
  }
  return obj;
}

function createObjEmpty() {
  const listObj = [];
  for (let i = 0; i < 6; i++) {
    if (i === ITEM_IMAGE_TYPE.ADAPTIVE) continue; // not show アダプティブドリル
    let obj = {
      imageType: i,
      thumbnailUrl: '',
      imageFileSelectType: 0 };
    obj = addNameAndTitle(obj, i);
    listObj.push(obj);
  }
  const objListObj = toObject(listObj);
  return objListObj;
}
function toObject(arr) {
  const rv = {};
  for (let i = 0; i < arr.length; ++i) { rv[arr[i].name] = arr[i]; }
  return rv;
}

export default function initialImage(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.INIT_INITIAL_IMAGE: {
      const initialImageObjectTemp = action.initialImageObject;
      return {
        ...state,
        initialImageObject: initialImageObjectTemp,
      };
    }
    case ActionTypes.INITIAL_IMAGE_LIST: {
      const initialImageListTemp = action.initialImageList;
      const imageListTemp = initialImageListTemp.imageList;
      // remove アダプティブドリル from initialImageList (imageType = 5)
      let deleteIndex = -1;
      for (let i = 0; i < imageListTemp.length; i++) {
        if (imageListTemp[i].imageType === ITEM_IMAGE_TYPE.ADAPTIVE) {
          deleteIndex = i;
          break;
        }
      }
      if (deleteIndex !== -1) {
        imageListTemp.splice(deleteIndex, 1);
      }

      let result = {};
      let obj = null;
      if (!imageListTemp && !imageListTemp.length) {
        obj = createObjEmpty();
      } else {
        imageListTemp.sort((a, b) => {
          const typeA = parseInt(a.imageType, 10);
          const typeB = parseInt(b.imageType, 10);
          if (isNaN(typeA) || isNaN(typeB)) return 0;
          if (typeA < typeB) return -1;
          if (typeA > typeB) return 1;
          return 0;
        });
        result = imageListTemp.reduce(
          (acc, cur) => {
            const { imageFileSelectType, imageType, thumbnailUrl } = cur;
            cur = addNameAndTitle(cur, imageType);
            cur.thumbnailUrl && (cur.thumbnailUrlFileLoad = cur.thumbnailUrl);
            acc.imageType[cur.name] = cur;
            acc.allImageTypes.push(imageType);
            return acc;
          },
          {
            imageType: {},
            allImageTypes: [],
          },
        );
        obj = result.imageType;
      }
      return {
        ...state,
        initialImageList: initialImageListTemp.imageList,
        initialImageObject: obj,
      };
    }
    default: {
      return state;
    }
  }
}
